import React, { useEffect } from 'react';

const TermsAndCondition = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  }, []);

  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1 className="terms-main-heading">Terms & Condition</h1>
        
        <div className="terms-content">
          <h2 className="terms-section-title">Terms of Use for Lutlo</h2>
          <p className="terms-date">Last Updated: November 7, 2025</p>
          
          <h3 className="terms-subtitle">1. Acceptance of Terms</h3>
          <p className="terms-text">
            By accessing and using the Lutlo website, you accept and agree to be bound by these Terms of Use. If you do not agree, please do not use our website.
          </p>

          <h3 className="terms-subtitle">2. Description of Service</h3>
          <p className="terms-text">
            Lutlo is a portfolio website that displays information about mobile applications we have developed and published on the Google Play Store and Apple App Store. The website is for informational purposes only.
          </p>

          <h3 className="terms-subtitle">3. Use of Website</h3>
          <p className="terms-text">
            You may use this website for lawful purposes only. You agree not to:
          </p>
          <ul className="terms-list">
            <li>Use the website in any way that violates applicable laws or regulations</li>
            <li>Attempt to interfere with the proper functioning of the website</li>
            <li>Copy, reproduce, or distribute content without permission</li>
            <li>Use automated systems to access the website without authorization</li>
          </ul>

          <h3 className="terms-subtitle">4. Intellectual Property</h3>
          <p className="terms-text">
            All content on the Lutlo website, including text, images, logos, and design elements, is the property of Lutlo and is protected by copyright laws. You may view and browse the content for personal, non-commercial use only.
          </p>

          <h3 className="terms-subtitle">5. External Links</h3>
          <p className="terms-text">
            Our website contains links to third-party websites (Google Play Store and Apple App Store). We are not responsible for the content, privacy practices, or terms of service of these external sites.
          </p>

          <h3 className="terms-subtitle">6. Disclaimer of Warranties</h3>
          <p className="terms-text">
            The Lutlo website is provided "as is" without any warranties, express or implied. We do not guarantee that the website will be error-free, uninterrupted, or free from viruses or other harmful components.
          </p>

          <h3 className="terms-subtitle">7. Limitation of Liability</h3>
          <p className="terms-text">
            Lutlo shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use of the website.
          </p>

          <h3 className="terms-subtitle">8. Modifications to Terms</h3>
          <p className="terms-text">
            We reserve the right to modify these Terms of Use at any time. Changes will be effective immediately upon posting to the website.
          </p>

          <h3 className="terms-subtitle">9. Governing Law</h3>
          <p className="terms-text">
            These Terms of Use shall be governed by and construed in accordance with the laws of India.
          </p>

          <h3 className="terms-subtitle">10. Contact Information</h3>
          <p className="terms-text">
            For questions about these Terms of Use, please contact us at{' '}
            <a href="mailto:support@lutlo.com" className="terms-email">support@lutlo.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsAndCondition;

